export default "__VITE_ASSET__D$Ip8Vg$__"